const audioFiles = [
    { index: 1, title: 'Eltern-Kind-Kuren', file: 'Eltern-Kind-Kuren.mp3' },
    { index: 2, title: 'AWO und gute Arbeit für alle', file: 'AWO-und-gute-Arbeit-fuer-alle.mp3' },
    { index: 3, title: 'AWO Bauernhöfe', file: 'AWO-Bauernhoefe.mp3' },
    { index: 4, title: 'Marie Jucharcz gründet die AWO', file: 'Marie-Jucharcz-gruendet-die-AWO.mp3' },
    { index: 5, title: 'AWO Seniorenzentren', file: 'AWO-Seniorenzentren.mp3' },
    { index: 6, title: 'Pflegeausbildung', file: 'Pflegeausbildung.mp3' },
    { index: 7, title: 'AWO und Demokratie', file: 'AWO-und-Demokratie.mp3' },
    { index: 8, title: 'CAP Supermaerkte', file: 'CAP-Supermaerkte.mp3' },
    { index: 9, title: 'AWO Reisedienste', file: 'AWO-Reisedienste.mp3' },
    { index: 10, title: 'Die AWO wird 100', file: 'Die-AWO-wird-100.mp3' },
    { index: 11, title: 'AWO Ambulante Pflege', file: 'AWO-Ambulante-Pflege.mp3' },
    { index: 12, title: 'AWO KITA', file: 'AWO-Kita.mp3' },
    { index: 13, title: 'AWO Jugendwerk', file: 'AWO-Jugendwerk.mp3' },
    { index: 14, title: 'Die AWO sagt willkommen', file: 'Die-AWO-sagt-willkommen.mp3' },
    { index: 15, title: 'AWO Ortsverein - Mitglied werden', file: 'AWO-Ortsverein-Mitglied-werden.mp3' },
    { index: 16, title: 'AWO für ein besseres Leben für alle', file: 'AWO-fuer-ein-besseres-Leben-fuer-alle.mp3' },
    { index: 17, title: 'Freiwilligendienste', file: 'Freiwilligendienste.mp3' }
];

var audioIsPlaying = false;

function isIE11() {
    return (navigator.userAgent.indexOf('Trident/7.0') != -1) && (navigator.userAgent.indexOf('rv:11.0') != -1);
}

function isSafari() {
    return (navigator.userAgent.indexOf('Safari') != -1) && (navigator.userAgent.indexOf('Chrome') == -1);
}

$(document).ready(function() {
    $(window).scroll(function() {
        $(document).scrollTop() > 50 ? $("#navbar").addClass("shrink") : $("#navbar").removeClass("shrink");
    });

    $(document).keydown(function( event ) {
        if (event.which == 68 && event.ctrlKey) {
            event.preventDefault();
            // toggle debug class
            $('body').toggleClass('debug');
        }
    });

    if (document.cookie.indexOf("cookieAccepted=") != -1) {
        $('#first-start-cookie-overlay').hide();
    }

    $('#close-info-panel').click(function() {
        $('#first-start').hide();
    });

    $('#agree-info-panel').click(function() {
        // create cookie to save acceptance
        document.cookie = "cookieAccepted=yes; expires=Tue, 31 Dec 2030 12:00:00 UTC; path=/";
        // hide cookie consent
        $('#first-start-cookie-overlay').hide();
    });

    $('.reveal-box--slider--audio-controller').click(function(){
        // get the audio player
        var audioPlayer = $("#audio-player");

        // check if the audio player is currently playing
        if(audioPlayer[0].paused) {
            // if audio player is paused, play track
            audioPlayer[0].play();
        }
        else {
            // if audio player is playing, pause track
            audioPlayer[0].pause();
        }

        // toggle show/hide play button
        $('#reveal-box--slider--audio-controller--play').toggleClass('show');
        $('#reveal-box--slider--audio-controller--play').toggleClass('hide');

        // toggle show/hide pause button
        $('#reveal-box--slider--audio-controller--pause').toggleClass('show');
        $('#reveal-box--slider--audio-controller--pause').toggleClass('hide');
    });

    $('.hidden-object--area').click(function(){
        // remove all classes and add default class
        $('#reveal-box').removeClass().addClass('hidden-object--reveal-box');

        // add reveal class to reveal box from data object of the clicked click-area
        $('#reveal-box').addClass($(this).data('reveal'));

        // get audio index
        var audioIndex = ($(this).data('audio') - 1);

        // get the audio player
        var audioPlayer = $("#audio-player");  
        
        // set the audio player source
        $("#source").attr("src", 'assets/audio/' + audioFiles[audioIndex].file);
        
        // stop all playing audio files
        audioPlayer[0].pause();
        
        // load new audio file
        audioPlayer[0].load();

        // set the popup title
        $('#popup-title').text(audioFiles[audioIndex].title);

        // reset the reveal slider
        // set the reveal box slider css properties
        $('#reveal-box--slider').css('left', '0');
        $('#reveal-box--slider--image').css('left', '0');

        // toggle show/hide play button
        $('#reveal-box--slider--audio-controller--play').addClass('show');
        $('#reveal-box--slider--audio-controller--play').removeClass('hide');

        // toggle show/hide pause button
        $('#reveal-box--slider--audio-controller--pause').removeClass('show');
        $('#reveal-box--slider--audio-controller--pause').addClass('hide');
    });

    // register event if the popup is closed
    $('#hidden-object--popup').on('hide.bs.modal', function (e) {
        // get the audio player
        var audioPlayer = $("#audio-player");

        // pause track
        audioPlayer[0].pause();
    });

    // register load event for audio player
    $("#audio-player").bind("load",function(){
        console.log("Audio Loaded succesfully");
    });

    // register ended event for controller switch
    $("#audio-player").bind("ended",function(){
        // toggle show/hide play button
        $('#reveal-box--slider--audio-controller--play').addClass('show');
        $('#reveal-box--slider--audio-controller--play').removeClass('hide');

        // toggle show/hide pause button
        $('#reveal-box--slider--audio-controller--pause').removeClass('show');
        $('#reveal-box--slider--audio-controller--pause').addClass('hide');
    });

    // register time update event for audio player
    $("#audio-player").bind("timeupdate",function(){
        // save current time of the audio file
        var $currentTime = $(this).prop('currentTime');
        // get the duration of the audio file
        var $duration = $(this).prop('duration');
        // calculate the current procentage
        var $currentAudioProcentage = ($currentTime * 100) / $duration;
        // get the width of the reveal box
        var $revealBoxWidth = $('#reveal-box').width();
        // calculacte the reveal box slider left position in pixel
        var $revealBoxAfterPosition = ($currentAudioProcentage * $revealBoxWidth) / 100;
        // trim the decimal numbers to two
        $revealBoxAfterPosition = $revealBoxAfterPosition.toFixed(0);
        // get the current background position for the reveal box slider
        var $revealBoxSliderBackgroundPosition = $('#reveal-box--slider').css('backgroundPosition').split(' ');
        // build the new background position
        if($revealBoxSliderBackgroundPosition.length == 2) {
            $revealBoxSliderBackgroundPosition = 'calc(' + $revealBoxSliderBackgroundPosition[0] + ' - ' + $revealBoxAfterPosition + 'px)' + ' ' + $revealBoxSliderBackgroundPosition[1];
        }
        else if($revealBoxSliderBackgroundPosition.length == 4) {
            // get the procentage
            var $tempProcent = $revealBoxSliderBackgroundPosition[0].split('(');
            // build the new background position 
            $revealBoxSliderBackgroundPosition = 'calc(' + $tempProcent[1] + ' - ' + $revealBoxAfterPosition + 'px)' + ' ' + $revealBoxSliderBackgroundPosition[3];
        }
        // set the reveal box slider css properties
        $('#reveal-box--slider').css('left', $revealBoxAfterPosition + 'px');
        $('#reveal-box--slider--image').css('left', ($revealBoxAfterPosition * -1) + 'px');
        //$('#reveal-box--slider').css('backgroundPosition', $revealBoxSliderBackgroundPosition);
    });

    // check if the browser is ie 10 or ie 11, because hacks!
    if(isIE11()) {
        // add class for hacks
        $('body').addClass('isIE11');
    }

    // check if the browser is Safari, because hacks!
    if(isSafari()) {
        // add class for hacks
        $('body').addClass('isSafari');
    }
});